import { useQuery } from '@tanstack/react-query';

import { postAssistantSuggestions } from '@/api/generated/assistant/assistant';
import type {
  PostAssistantSuggestionsBody,
  PostAssistantSuggestionsBodyScope,
} from '@/api/generated/lucioAPI.schemas';
import { queryKeys } from '@/config/query/queryKeys';

interface UseSuggestionsOptions {
  conversationId?: string;
  enabled?: boolean;
  messageId?: string;
  scope: 'EMAIL' | 'THREAD' | 'INBOX';
  sessionId?: string;
}

export const useSuggestions = ({
  conversationId,
  enabled = true,
  messageId,
  scope,
  sessionId,
}: UseSuggestionsOptions) => {
  return useQuery({
    enabled:
      enabled &&
      (scope === 'INBOX' ||
        (scope === 'EMAIL' && !!messageId) ||
        (scope === 'THREAD' && !!conversationId)),
    queryFn: async () => {
      const request: PostAssistantSuggestionsBody = {
        scope: scope as PostAssistantSuggestionsBodyScope,
        ...(scope === 'EMAIL' && messageId && { messageId }),
        ...(scope === 'THREAD' && conversationId && { conversationId }),
      };

      return postAssistantSuggestions(request);
    },
    queryKey: queryKeys.chat.suggestions(scope, sessionId, messageId, conversationId),
    retry: 1,
    retryDelay: 1000,
    staleTime: 5 * 60 * 1000,
  });
};
